import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
};

const advisoryDelReducer = createReducer(initialState, {
  ADVISORY_DEL_REQ: (state) => {
    state.loading = true;
    state.user = null;
  },
  ADVISORY_DEL_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  ADVISORY_DEL_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default advisoryDelReducer;
